import type { Supplier } from "@/client";

const money = new Intl.NumberFormat("pt-BR", {
	style: "currency",
	currency: "BRL",
});

const day = new Intl.DateTimeFormat("pt-BR", {
	day: "2-digit",
	month: "short",
	timeZone: "America/Sao_Paulo",
});

const moment = new Intl.DateTimeFormat("pt-BR", {
	day: "2-digit",
	month: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	timeZone: "America/Sao_Paulo",
});

const supplierKindLabels: Record<Supplier["kind"], string> = {
	MILL: "Usina",
	TRADING: "Trading",
	CARRIER: "Transportadora",
	OTHER: "Fornecedor",
};

function formatMoney(cents: number) {
	return money.format(cents / 100);
}

function formatDecimal(value: string) {
	const [integer, decimals] = value.split(".");
	const significantDecimals = decimals?.replace(/0+$/u, "");

	if (!significantDecimals) {
		return integer;
	}

	return `${integer},${significantDecimals}`;
}

export const FinancePresentation = {
	money: formatMoney,
	decimal: formatDecimal,
	signedMoney(cents: number) {
		if (cents === 0) {
			return formatMoney(0);
		}

		return `${cents > 0 ? "+" : "−"}${formatMoney(Math.abs(cents))}`;
	},
	transactionDate(value: string) {
		return day.format(new Date(`${value}T12:00:00-03:00`)).replace(".", "");
	},
	moment(value: string) {
		return moment.format(new Date(value));
	},
	supplierKind(kind: Supplier["kind"]) {
		return supplierKindLabels[kind];
	},
	taxId(taxId: string) {
		return taxId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/u, "$1.$2.$3/$4-$5");
	},
};
